import { render, staticRenderFns } from "./companyIinformation.vue?vue&type=template&id=49763cc2&scoped=true&"
import script from "./companyIinformation.vue?vue&type=script&lang=js&"
export * from "./companyIinformation.vue?vue&type=script&lang=js&"
import style0 from "./companyIinformation.vue?vue&type=style&index=0&id=49763cc2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49763cc2",
  null
  
)

export default component.exports